<template>
  <DBox
    :id="'cmp-catalog-products-gema'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new') + ' ' + $t('media')"
    @addClick="addProductMedia"
  >
    <div class="ut-fh">
      <NTable
        class="dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
        :id="'accounting-invoices-invoice_line'"
        :showNoItems="false"
        height="170px"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('media')">
              <span>{{ item["set_no"] }}</span>
            </td>
            <td @click="onRegistrationClick(item)" v-bind="tdcon('registration')">
              <span class="ut-link ut-text-accent5">{{
                item["mechanical_reg_no"]
              }}</span>
            </td>
            <td v-bind="tdcon('type')">
              <span>{{ item["media_name"] }}</span>
            </td>
            <td v-bind="tdcon('time')">
              <span>{{ item["total_palytime"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteMedia(item)"
                  :alt="$t('delete_related_contact')"
                  :title="$t('delete_related_contact')"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import { openMailWindow } from "@/utility";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    TextField,
    NTable,
    DBox,
  },
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("media", { f: 0.5 }),
        createTableHeader("registration"),
        createTableHeader("type"),
        createTableHeader("time"),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    list: function () {
      return this.selectedProductDetails.product_medias || [];
    },
  },
  methods: {
    onDeleteMedia:function(item){
      this.$emit("delete",item)
    },
    onTextInputBlur: function (event, name, item) {
      console.log(event);
      const value = event.value;
      this.$emit("changed", { name, value, item });
    },
    onContactNameClick: function (contact) {
      this.$emit("contact_selected", contact);
    },
    onMail: function (contact) {
      openMailWindow(`mailto: ${contact.email1}`);
    },
    // onRegistrationClick:function(item){
    //     this.$router.push({
    //     ...this.$route,
    //     query: {
    //       modal: "add_contact_relation",
    //       external_id: this.external_id,
    //       external_table: this.external_table,
    //     },
    //   });
    // },
 
    onDeleteRelatedContact: function (contact) {
      this.$emit("delete", contact);
    },
    onProductExclude: function (e, item) {
      if (e.target.selected) {
        this.$emit("changed", { name, value, item });
      }
    },
    onRegistrationClick:function(item){
        
        console.log("ITEM",item);
        this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_media",
          external_id:this.selectedProductDetails.product.product_id,
          product_media_id:item.product_media_id,
          mode:'edit'
        },
      });
    },
    addProductMedia:function(){
          this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_media",
          external_id:this.selectedProductDetails.product.product_id,
          mode:'add'
        },
      });
    }
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-gema {
  .dt-ntable {
    th.exclude {
      span {
        /* margin: 0px 8px; */
      }
    }
  }
}
</style>
